import React, { useState } from 'react'

const NewRestartIcon = ({ color = '#fff', hoverColor = '#bbfa33' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.077"
      height="17.514"
      viewBox="0 0 19.077 17.514"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <g data-name="Group 1186">
        <g style={{ fillRule: 'evenodd', fill: 'none', strokeLinecap: 'round' }}>
          <path
            d="m5.218 12.014 9.013 5.735a.471.471 0 0 0 .724-.4V5.882a.471.471 0 0 0-.724-.4L5.218 11.22a.471.471 0 0 0 0 .794z"
            style={{ stroke: isHovered ? hoverColor : color }}
            transform="translate(1.623 -2.81)"
          />
          <path
            d="M14.482 17.824a.471.471 0 0 0 .472-.472V5.882a.47.47 0 0 0-.723-.398L5.218 11.22a.47.47 0 0 0 0 .794l9.013 5.736c.08.05.167.074.251.074m0 2.5c-.564 0-1.115-.16-1.593-.465l-9.013-5.736A2.957 2.957 0 0 1 2.5 11.617c0-1.021.515-1.959 1.376-2.507l9.013-5.735a2.965 2.965 0 0 1 1.593-.465 2.975 2.975 0 0 1 2.972 2.972v11.47a2.975 2.975 0 0 1-2.972 2.972z"
            style={{ fill: isHovered ? hoverColor : color, stroke: isHovered ? hoverColor : color }}
            transform="translate(1.623 -2.81)"
          />
        </g>
        <path
          data-name="Path"
          transform="translate(1.25 1.25)"
          style={{
            stroke: isHovered ? hoverColor : color,
            strokeWidth: '2.5px',
            fill: 'none',
            strokeLinecap: 'round',
          }}
          d="M0 0v15"
        />
      </g>
    </svg>
  )
}

export default NewRestartIcon
